var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8h24l10 10v38H15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 8v12h12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32h18M23 41h18"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 48,
    r: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentOpen);
export default __webpack_public_path__ + "static/media/document-open.cc0da26ea9e29aae154ba5f8189f8f1d.svg";
export { ForwardRef as ReactComponent };